import axios from 'axios';
import qs from 'qs';
import { createLoader } from 'helpers/loader/loader';

const highlightCurrentDay = (exceptionElement) => {
    const currentDate = new Date(); //Get the date of today
    const formattedCurrentDate = currentDate.toLocaleString('nl-NL', {
        year: 'numeric', // "2020"
        month: '2-digit', // "05"
        day: '2-digit' // "01"
    }); //Format date to 01-01-2020
    let activeDate = exceptionElement.querySelector('[data-date="' + formattedCurrentDate + '"]'); //Try to find  matching element in exceptions

    //If no exception date is available. Select a regular weekday.
    if (!activeDate) {
        const currentDayNumber = currentDate.getDay(); //Get current day number
        const openingHoursTable = document.querySelector('.opening-hours'); //Select openinghours table
        activeDate = openingHoursTable.querySelector('[data-day="' + currentDayNumber + '"]'); //Select active day
    }

    //Check if active date exist
    if (activeDate) {
        activeDate.classList.add('fw-bold', 'text-primary'); //Highlight element
    }
};

export const init = () => {
    const openingHoursTable = document.querySelector('table.opening-hours');
    const exceptionElement = document.getElementById('showroom-exceptions'); //Select openingshours exception element

    if (openingHoursTable) {
        highlightCurrentDay(openingHoursTable);
    }

    //Check if element exists
    if (!exceptionElement) {
        return;
    }
    const settings = {
        showroomId: exceptionElement.getAttribute('data-id'),
        type: exceptionElement.getAttribute('data-type'),
        url: exceptionElement.getAttribute('data-url')
    };

    createLoader(exceptionElement); //Add loader to element

    //Collect data to send
    const params = {};
    params.type = settings.type;
    params.id = settings.showroomId;
    //Do ajax call
    axios.post(settings.url, qs.stringify(params)).then(function (response) {
        exceptionElement.innerHTML = response.data;
        highlightCurrentDay(exceptionElement);
    });
};
